﻿$.fn.dxCtrlPopupSaisieTelTest = function custom_dxCtrlPopupSaisieTelTest(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlpopupsaisieteltest dx-ctrl");
        this.createInstance(new cdxCtrlPopupSaisieTelTest(this, option));
    }
    return this;
}

window.cdxCtrlPopupSaisieTelTest = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    this.pop = null
    function mConstruit() {
        container.empty();
        container.remove()
        var dxTel = null
        if (typeof option.bddCtrl.utiCourantParaJson.sms == 'undefined') option.bddCtrl.utiCourantParaJson.sms = {}
        if (typeof option.bddCtrl.utiCourantParaJson.sms.code_pays_test_sms == 'undefined') option.bddCtrl.utiCourantParaJson.sms.code_pays_test_sms = "fr"
        if (typeof option.bddCtrl.utiCourantParaJson.sms.tel_test_sms == 'undefined') option.bddCtrl.utiCourantParaJson.sms.tel_test_sms = "06"

        var dxTel = null;
        Me.pop = container.appendTo("body").dxCtrlPopupBase({
            fullScreen: false,
            showTitle: true,
            shading: true,
            showMaximize: false,
            width: 500,
            height: "auto",
            title: "Saisie adresse email",
            onShown: function (e) { dxTel.focus() },
            contentTemplate: function (contentElement) {
                if (typeof option.bddCtrl.utiCourantParaJson.lst_email_test == "undefined") option.bddCtrl.utiCourantParaJson.lst_email_test = []
                option.bddCtrl.mSaveParaJsonUtilisateur();

                $("<div style='padding:0 10px;'>Prévisualisation de votre message</diV>").appendTo(contentElement)
                $("<div style='padding:0 10px;font-size:70%;font-style:italic;'>Pour tester votre message, nous utilisons les hyper-liens originaux de votre message.<br/>A l'envoi final de votre message, tous vos hyper-liens seront remplacés par des hyper-liens de tracking court (32 caractères)</diV>").appendTo(contentElement)
                var $DivPreview = $("<div style='margin:5px 15px 15px 15px;padding:15px;border:" + theme.border + ";background-color:white;color:black;'/>").appendTo(contentElement)
                $DivPreview.html(option.sendSms.mGetTxtWithLinkInHtml(false))

                $("<div style='padding:10px;'>Saisissez le numéro de téléphone ou envoyer le sms de test</diV>").appendTo(contentElement)
                dxTel = $("<div/>").appendTo(contentElement).dxCtrlTelephone({
                    labelMode: 'floating',
                    label: "N° mobile de test",
                    typeTel: "mob",
                    disableIndicatif: true,
                    value: {
                        tel_code_pays: option.bddCtrl.utiCourantParaJson.sms.code_pays_test_sms,
                        tel_number: "",
                        tel_complet: "+" + option.bddCtrl.utiCourantParaJson.sms.tel_test_sms,
                        tel_sms: option.bddCtrl.utiCourantParaJson.sms.tel_test_sms,
                        tel_error: "-1",
                        tel_num_type: "-1"
                    }
                }).dxCtrlTelephone("instance")
                $("<div style='padding:5px;'>" + option.nbCaractereMessage + " caractères pour votre message &bull; " + option.nbCreditMessage + " crédit" + ((option.nbCreditMessage > 1) ? "s" : "") + "</div>").appendTo(contentElement)

                $("<br/>").appendTo(contentElement)
                mAddButtonOkAnnuler(contentElement,
                    function () { //ok
                        if (dxTel.option("value").tel_error == "-1") {
                            option.bddCtrl.utiCourantParaJson.sms.code_pays_test_sms = dxTel.option("value").tel_code_pays
                            option.bddCtrl.utiCourantParaJson.sms.tel_test_sms = dxTel.option("value").tel_sms
                            option.bddCtrl.mSaveParaJsonUtilisateur();
                            option.onValidate(dxTel.option("value").tel_code_pays, dxTel.option("value").tel_sms)
                            Me.pop.hide()
                        } else {
                            mNotify("Veuillez saisir un numéro de téléphone valide.", "warning", 6000)
                        }
                    },
                    function () { //annuler
                        Me.pop.hide();
                    }, null, "Envoyer")
            }
        }).dxCtrlPopupBase("instance")
        Me.pop.show()
    }

    this.element = function () { return container }
    this.component = function () { return Me; }

    mConstruit();
}